module.exports = __webpack_public_path__ + "img/idex.0efb47c5.png";